// /*************************** Sticky cart *****************************/
// window.addEventListener("scroll", (event) => {
//   let scroll = this.scrollY;
//   let stickPurchase = document.querySelector('.sticky-buttons');

//   if (scroll <= 600) {
//     stickPurchase.classList.add('fixed');
//     stickPurchase.classList.remove('hide');
//   }
//   // else if (scroll > 600 && scroll <= 1200) {
//   //   stickPurchase.classList.remove('fixed');
//   //   stickPurchase.classList.add('hide');
//   // } 
//   else {
//     stickPurchase.classList.add('fixed');
//     stickPurchase.classList.remove('hide');
//   }
// });




/*************************** Sticky cart *****************************/
let lastScrollY = 0; // Track previous scroll position

window.addEventListener("scroll", (event) => {
  let scroll = window.scrollY; // Use window.scrollY, not this.scrollY
  let stickPurchase = document.querySelector('.sticky-buttons');
  
  // Determine scroll direction
  let isScrollingDown = scroll > lastScrollY;
  
 
  if (scroll <= 400) {
    // User is near top of page
    if (isScrollingDown) {
      // Scrolling down - show it
      stickPurchase.classList.add('fixed');
      stickPurchase.classList.remove('hide');
    } else {
      // Scrolling up - hide it
      stickPurchase.classList.remove('fixed');
      stickPurchase.classList.add('hide');
    }
  } else {
    // User is past 600px - show it
    stickPurchase.classList.add('fixed');
    stickPurchase.classList.remove('hide');
  }
  
  // Update last scroll position
  lastScrollY = scroll;
});



